import type { IconSvgObject } from './types';

const EiffelTowerIcon: IconSvgObject = [
  ["path", { d: "M3 22C7.88209 16.7924 9.6328 9.96623 10.6495 5.10062C10.7833 4.46002 11.3456 4 12 4C12.6544 4 13.2167 4.46002 13.3505 5.10062C14.3672 9.96623 16.1179 16.7924 21 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 2V4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7 22C7.72781 19.6696 9.69162 18 12 18C14.3084 18 16.2722 19.6696 17 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7.5 11H16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M6 15H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default EiffelTowerIcon;
